import { ModalStatus } from "@/constants/modal";
import { ICashFloat } from "@/interfaces/cash-float/cash-float";
import { GroupInfo } from "@/types/gql/group";
import { AxiosError, InternalAxiosRequestConfig, AxiosResponse } from "axios";

// let authHeaderCallback:  = null;
// let gqlAuthHeader:  = null;

export const SharedCallbacks: {
  authHeaderCallback:
    | null
    | ((
        conf: InternalAxiosRequestConfig
      ) => Promise<InternalAxiosRequestConfig>);
  gqlAuthHeader: null | (() => Promise<string>);
  getSellerId: null | (() => number);
  getPOSConfigId: null | (() => number);
  getGroupInfo: null | (() => GroupInfo);
  UserLogOut: null | ((data?: { signWorkOutEvent: boolean }) => string);
  ModalSetStatus: null | ((status: ModalStatus) => void);
  cashfloat: null | (() => ICashFloat | null);
  monitorLatencyCallback:
    | null
    | ((response: AxiosResponse, error?: AxiosError) => void);
  startTimeMetadataCallback:
    | null
    | ((conf: InternalAxiosRequestConfig) => void);
} = {
  authHeaderCallback: null,
  gqlAuthHeader: null,
  getSellerId: null,
  getPOSConfigId: null,
  getGroupInfo: null,
  UserLogOut: null,
  ModalSetStatus: null,
  cashfloat: null,
  monitorLatencyCallback: null,
  startTimeMetadataCallback: null,
};
